import { getToken, getTokenHeader } from '../../../screen/auth/action';
import { axios } from '../../../utils/settings';
import { getCompanySuppliersUrl, getSearchProductsUrl, searchCompanyUrl } from '../url';

export const fetchSkuFilterAction = async (searchIndex, queryData) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        `${getSearchProductsUrl()}?search_index=${searchIndex}&filter=true`,
        queryData,
        { ...getTokenHeader(token) },
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getCompanySuppliersAction = async (
  module = 'default',
  params = {},
) => {
  return new Promise(async (next) => {
    let token = await getToken();
    if (params instanceof URLSearchParams) {
      params.append('module', module);
    } else {
      params = new URLSearchParams(params);
      params.append('module', module);
    }
    await axios
      .get(getCompanySuppliersUrl(), {
        ...getTokenHeader(token),
        params,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const searchCompanyAction = (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        searchCompanyUrl(),
        data,
        getTokenHeader(token)
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};